import { render, staticRenderFns } from "./geetest.vue?vue&type=template&id=3f3c8f57&scoped=true&"
import script from "./geetest.vue?vue&type=script&lang=js&"
export * from "./geetest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c8f57",
  null
  
)

export default component.exports